import script from "./otherFormThird.vue?vue&type=script&setup=true&lang=js"
export * from "./otherFormThird.vue?vue&type=script&setup=true&lang=js"

import "./otherFormThird.vue?vue&type=style&index=0&id=8867f4aa&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8867f4aa"]])

export default __exports__